export const RENTAL_STATUS = {
  pending: { color: 'blue', text: '待处理' },
  awaitingBilling: { color: 'orange', text: '待出账' },
  active: { color: 'success', text: '生效中' },
  ended: { color: 'purple', text: '已结束' },
  cancelled: { color: 'error', text: '已取消' },
  archived: { color: 'default', text: '已归档' }
}

export const RENT_UNITS = { daily: '日', monthly: '月', yearly: '年' }
